import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { socialMedia as defaultSocials } from '@config';
import { Side } from '@components';
import { Icon } from '@components/icons';
import { fetchFromApi } from '@utils/api';

const StyledSocialList = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;

  &:after {
    content: '';
    display: block;
    width: 1px;
    height: 90px;
    margin: 0 auto;
    background-color: var(--light-slate);
  }

  li {
    &:last-of-type {
      margin-bottom: 20px;
    }

    a {
      padding: 10px;

      &:hover,
      &:focus {
        transform: translateY(-3px);
      }

      svg {
        width: 20px;
        height: 20px;
      }
    }
  }
`;

const Social = ({ isHome }) => {
  const [socials, setSocials] = useState(defaultSocials);

  useEffect(() => {
    const loadSocials = async () => {
      const profile = await fetchFromApi('/profile');
      if (profile) {
        const dynamicSocials = [];
        if (profile.github) dynamicSocials.push({ name: 'GitHub', url: profile.github });
        if (profile.instagram) dynamicSocials.push({ name: 'Instagram', url: profile.instagram });
        if (profile.linkedin) dynamicSocials.push({ name: 'Linkedin', url: profile.linkedin });
        if (profile.email) dynamicSocials.push({ name: 'Mail', url: `mailto:${profile.email}` });

        if (dynamicSocials.length > 0) {
          setSocials(dynamicSocials);
        }
      }
    };
    loadSocials();
  }, []);

  return (
    <Side isHome={isHome} orientation="left">
      <StyledSocialList>
        {socials &&
          socials.map(({ url, name }, i) => (
            <li key={i}>
              <a href={url} aria-label={name} target="_blank" rel="noreferrer">
                <Icon name={name} />
              </a>
            </li>
          ))}
      </StyledSocialList>
    </Side>
  );
};

Social.propTypes = {
  isHome: PropTypes.bool,
};

export default Social;
